import React from "react";
import Header from "@/components/landing/Header";
import Hero from "@/components/landing/Hero";
import WhatIs from "@/components/landing/WhatIs";
import MapSection from "@/components/landing/MapSection";
import XPSystem from "@/components/landing/XPSystem";
import TrollGallery from "@/components/landing/TrollGallery";
import Specials from "@/components/landing/Specials";
import Seasons from "@/components/landing/Seasons";
import Merchants from "@/components/landing/Merchants";
import Pricing from "@/components/landing/Pricing";
import FAQ from "@/components/landing/FAQ";
import InstallBar from "@/components/landing/InstallBar";
import Footer from "@/components/landing/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="paper-texture min-h-screen bg-parchment text-ink font-body">
      <Header />
      <main>
        <Hero />
        <WhatIs />
        <MapSection />
        <XPSystem />
        <TrollGallery />
        <Specials />
        <Seasons />
        <Merchants />
        <Pricing />
        <FAQ />
      </main>
      <Footer />
      <InstallBar />
    </div>
  );
}
